import React from 'react';
import { Badge } from 'reactstrap';

const BadgeField = ({ value, data, ...props }) => {
  return (
    <div {...props}>
      {value == true ? (
        <Badge className="badge-signed">Si</Badge>
      ) : value == false ? (
        <Badge style={{ backgroundColor: 'red' }}>No</Badge>
      ) : (
        <div>-</div>
      )}
    </div>
  );
};
export default BadgeField;
